export default "__VITE_ASSET__CDtZwcnF__"